<template>
    <div class="header-body-container-final">
        <div class="content-container">
            <div class="section-body">
                <div class="header-content">
                    Excellent choice, <span class="name">{{ person.name }}!</span>
                </div>
                <div class="body-content">
                    One of our seasoned travel professionals will contact you shortly.
                </div>
                <div class="middle-line"></div>
                <div class="footer-content">
                    <div class="main-message">
                        If you cannot wait<span class="hide-on-mobile"> please call us</span>.
                    </div>
                    <a class="tel-number" :href="`tel:${$globalConfig.contacts.phone}`">
                        {{ $globalConfig.contacts.phone }}
                    </a>
                </div>
            </div>
            <button class="btn" @click="$router.go(-2)">Explore more</button>
        </div>

        <div class="image-container">
            <img class="bottom-right-image" src="../../../assets/svgs/Group 7919.svg" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FinishSection',
    props: ['person'],
}
</script>

<style lang="scss" scoped>
@import 'shared/common-forms-styles';
@import '../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.header-body-container-final {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 60px auto;

    .content-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .section-body {
            background-color: rgba(192, 192, 201, 0.12);
            display: flex;
            border-radius: 7px;
            flex-direction: column;
            margin: 45px auto;
            position: relative;
            max-width: 1100px;
            z-index: 50;
            padding: 70px 35px 35px;
            align-items: flex-start;

            .header-content {
                font-family: 'Gilroy-Regular', sans-serif;
                font-size: 26px;
                line-height: 31px;
                color: $mainTextBlueColor;
                text-align: left;

                .name {
                    font-family: 'Gilroy-Bold', sans-serif;
                    color: $mainTextBlueColor;
                    font-weight: bold;
                }
            }

            .body-content {
                font-family: 'Gilroy-Regular', sans-serif;
                font-size: 20px;
                line-height: 24px;
                color: $mainTextBlueColor;
                text-align: left;
                padding: 20px 0;
                max-width: 500px;
            }

            .middle-line {
                width: calc(100% + 70px);
                margin: 0 -35px;
                border-bottom: 0.5px solid #cbcbcb;
            }

            .footer-content {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                margin-top: 40px;

                .main-message {
                    font-family: 'Gilroy-Regular', sans-serif;
                    font-size: 20px;
                    line-height: 24px;
                    color: $mainTextBlueColor;
                    text-align: center;
                }

                .tel-number {
                    font-family: 'Gilroy-Medium', sans-serif;
                    font-weight: bold;
                    font-size: 22px;
                    line-height: 26px;
                    color: $mainTextBlueColor;
                    text-align: center;
                    text-decoration: none;
                    outline: none;
                    margin: 0 20px;
                }
            }
        }
    }

    .image-container {
        background: url('../../../assets/images/Header/pexels-andrea-piacquadio-837129.png');
        width: 478px;
        height: 530px;
        border-radius: 20px 20px 20px 20px;
        background-position: -90px 0px;
        position: relative;
        margin-left: 20px;

        .bottom-right-image {
            position: absolute;
            right: -30px;
            bottom: -30px;
        }
    }
}

@media (max-width: 1200px) {
    .header-body-container-final {
        .image-container {
            width: 378px;
            height: 420px;
        }
    }
}

@media (max-width: 992px) {
    .header-body-container-final {
        padding: 0;
        padding-top: 50px;

        .image-container {
            width: 286px;
            height: 318px;
            background-size: 596px 397px;
            background-position: -50px 0px;
        }
    }
}

@media (max-width: 768px) {
    .header-body-container-final {
        display: flex;
        justify-content: space-between;
        padding: 0;

        .content-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            background-color: rgba(192, 192, 201, 0.12);
            border-radius: 7px;
            padding-bottom: 50px;
            margin: auto;

            .section-body {
                padding: 30px 25px 0;
                align-items: center;
                background: unset;
                margin-bottom: 0;

                .header-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .name {
                        margin-top: 10px;
                    }
                }

                .body-content {
                    font-size: 16px;
                    line-height: 19px;
                    text-align: center;
                    padding: 40px 0;
                    max-width: 300px;
                }

                .middle-line {
                    width: calc(100% + 50px);
                    margin: 0 -25px;
                }

                .footer-content {
                    flex-direction: column;

                    .main-message {
                        padding: 10px 0 25px;
                        max-width: 300px;
                        font-size: 26px;
                        line-height: 39px;

                        span.hide-on-mobile {
                            display: none;
                        }
                    }

                    .tel-number {
                        padding: 25px 0 50px;
                        font-size: 26px;
                        line-height: 39px;
                        font-family: 'Gilroy-Bold', sans-serif;
                    }
                }
            }
        }

        .image-container {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/FinishSection.vue